import { Label } from 'reaflow'

export default function NodeLabel({ tooltipText, ...props }) {
  return <Label {...props} originalText={tooltipText} />
}
